import { render, staticRenderFns } from "./MovieTicket.vue?vue&type=template&id=4350be40&"
import script from "./MovieTicket.vue?vue&type=script&lang=js&"
export * from "./MovieTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports